import { createSlice } from "@reduxjs/toolkit";

const initalHeaderState = {
    isHeaderShrink: false
}

const headerSlice = createSlice({
    name: 'header',
    initialState: initalHeaderState,
    reducers:{
        setIsShrink(state,action) {
            state.isHeaderShrink = action.payload;
        }
    }
});

export const headerActions = headerSlice.actions;

export default headerSlice.reducer;